import { invariant } from '@streem/toolbox';
// TODO it would be good to support validating the value type
export function validateConfigShape(requiredKeys, config) {
    invariant(typeof config === 'object', 'config should be object');
    const missingKeys = [];
    requiredKeys.forEach(key => {
        if (!Object.prototype.hasOwnProperty.call(config, key)) {
            missingKeys.push(key);
        }
    });
    if (missingKeys.length) {
        throw new Error(`Missing required key${missingKeys.length > 1 ? 's' : ''}: ${missingKeys.join(', ')}`);
    }
}
//# sourceMappingURL=validate_config_shape.js.map